







































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { createTask, queryTask } from '@/api/document';

@Component({})
class CREATEREVIEW extends Vue {
  type: any;
  reviewInfo: object = {
    date: '',
    targetFolder: '',
    sourceFolder: ''
  };
  rules: object = {
    targetFolder: [{ required: true, message: '文件夹不能为空', trigger: 'blur' }],
    sourceFolder: [{ required: true, message: '', trigger: 'blur' }]
  };
  yearList: any[] = [];
  yearSelected: string = '';
  quarterSelected: string = '';
  quarterList: any[] = ['H1', 'H2'];
  sourceFolderList: any[] = [];

  created() {
    this.type = this.$route.query.type;
    if (this.type === '3') {
      this.getQueryTask();
    } else {
      this.getDateList();
      if (this.type === '2') {
        this.sourceFolderList = [
          {
            id: `${Math.random()}`,
            content: ''
          },
          { id: `${Math.random()}`, content: '' },
          { id: `${Math.random()}`, content: '' }
        ];
      }
    }
  }

  get targetFolder() {
    return this.reviewInfo['targetFolder'];
  }

  get sourceFolder() {
    return this.sourceFolderList
      .filter(_ => _.content)
      .map(_ => _.content)
      .join(',');
  }

  async getQueryTask() {
    try {
      let res = await queryTask({
        year: this.$route.query.year,
        quarter: this.$route.query.quarter
      });
      if (res.code === 200) {
        if (res.data.sourceFolderList) {
          this.sourceFolderList = res.data.sourceFolderList.split(',').map(_ => {
            return {
              content: _,
              id: `${Math.random()}`
            };
          });
        }
        this.reviewInfo['targetFolder'] = res.data.targetFolder;
        this.yearSelected = this.$route.query.year + '';
        this.quarterSelected = 'H' + this.$route.query.quarter;
      } else {
        this.$message.error(res.msg);
      }
    } catch (err) {
      console.log(err);
    }
  }

  getDateList() {
    let myDate = new Date();
    let year = myDate.getFullYear();
    this.yearList.push(year.toString());
    let num = 1;
    while (num <= 20) {
      this.yearList.push((year + num).toString());
      this.yearList.unshift((year - num).toString());
      num++;
    }
    this.yearSelected = year.toString();
    let month = myDate.getMonth();
    let quarter = month > 6 ? 2 : 1;
    this.quarterSelected = 'H' + quarter.toString();
  }

  async createReview() {
    try {
      if (this.valid()) {
        let reg = /H/g;
        let data = {
          year: this.yearSelected,
          quarter: this.quarterSelected.replace(reg, ''),
          targetFolder: this.targetFolder
        };
        if (this.type === '2' || this.type === '3') {
          data['sourceFolderList'] = this.sourceFolder;
        }
        let res = await createTask(data);
        if (res.code === 200) {
          this.$message.success('保存成功');
          this.toBack();
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  toBack() {
    this.$router.push({ path: '/document/portfolioReview/' });
  }

  valid() {
    if (!this.targetFolder) {
      this.$message.error('已整理好Review文件夹不能为空');
      return false;
    }
    if (this.type === '2' && this.sourceFolder === '') {
      this.$message.error('待整理review文件夹不能为空');
      return false;
    }
    return true;
  }

  addSourceInput() {
    this.sourceFolderList.push({
      id: `${Math.random()}`,
      content: ''
    });
  }

  deleteInput(id) {
    let index = this.sourceFolderList.findIndex(_ => _.id === id);
    this.sourceFolderList.splice(index, 1);
  }

  toFile(url) {
    window.open(url);
  }
}
export default CREATEREVIEW;
